<template>
  <div>
    <v-card color="#003073" class="my-md-3 site-header">
      <!-- <v-card-text style="color: white">
        <a href="/"><img src="../assets/teleflex-logoNoReg.png"/></a>
        <span class="text-style text-h6 font-weight-regular">
          Document Library International
        </span>
      </v-card-text> -->
      <v-img
        src="../assets/libraryBanner.png"
        position="left"
        min-height="200"
      />
    </v-card>
    <div v-if="$store.state.isIE && $store.state.user.isAuthorized">
      <v-card class="site-header" color="warning">
        <v-card-text class="mb-3">
          <strong>Warning</strong> - Modifying data is not supported in Internet
          Explorer. Please use Edge, Firefox, Chrome, or another modern browser
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE '); //ie 10 or older
    var trident = ua.indexOf('Trident/'); //ie 11

    if (msie > 0 || trident > 0) {
      this.$store.state.isIE = true;
    }
  }
};
</script>

<style scoped>
.site-header {
  min-width: 100%;
}
.text-style {
  margin-left: 0.5em;
  display: inline-block;
}
</style>
